import React, { useState } from "react";
import { Modal } from "antd";
import NewCrmPatientWizard from "../../patients/newPatient/NewCrmPatientWizard";
import PatientCard from "../../patients/patientCard";
import { reset } from "../../patientDetails/patientDetailsSlice";
import { useDispatch, useSelector } from "react-redux";

const ConvertOrCreateWizard = (props) => {
  const { visible, hide, type, fromCrm, refetch } = props;
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [patientCardVisible, setPatientCardVisible] = useState(false);
  const dispatch = useDispatch();
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );

  const onShowPatientCardClicked = (record, show) => {
    setSelectedPatient(record);
    setPatientCardVisible(true);
  };

  const onHidePatientCardModal = () => {
    setPatientCardVisible(false);
    dispatch(reset());
  };

  return (
    <>
      <Modal
        closable={false}
        maskClosable={false}
        footer={null}
        width={"1000px"}
        styles={{
          body: {
            padding: 0,
          },
        }}
        title={null}
        open={visible}
        onCancel={hide}
        destroyOnClose={true}
      >
        <NewCrmPatientWizard
          hideWizard={() => {
            if (refetch) {
              refetch();
            }
            hide();
          }}
          onShowPatientCardClicked={onShowPatientCardClicked}
          type={type}
          record={activePatient}
          fromCrm={fromCrm}
        />
      </Modal>
      <PatientCard
        record={selectedPatient}
        onHide={onHidePatientCardModal}
        visible={patientCardVisible}
        showScheduling={false}
      />
    </>
  );
};

export default ConvertOrCreateWizard;
